module.exports = __webpack_public_path__ + "images/internal/feedback_widget_img.png";